import React, {useEffect, useState} from 'react'
import Chart from 'react-apexcharts'
import {Col, Row, Spinner, Stack} from 'react-bootstrap'
import { chartOptions } from '../../../utils/helper'

interface Props {
  utilityMix?: any
  reload: any
}

function UtilitMix({utilityMix, reload}: Props) {
  const [utilSeries, setUtilSeries] = useState<any>([])
  const [colors, setColors] = useState<any>([])
  const [labels, setLabels] = useState<any>([])
  const [utilityMixData, setUtilityMixData] = useState<any>([])

  useEffect(() => {
    updateData(utilityMix)
  }, [utilityMix])

  const updateData = (data: any) => {
    const utilitySeriesUpdated = data?.utilities?.map((item: any, i: any) => item?.tpvAcceptedCount)
    setUtilSeries(utilitySeriesUpdated)
    
    const arrayColor = [
      "#50CD89",
      "#F6C000",
      "#009EF6",
      "#5E6278",
      '#009EF6',
      '#77FAC6',
      '#36C190',
      '#008A5E',
      '#EAE784',
      '#B1AF50',
      '#7A7B1B',
      '#FFC6A3',
      '#F88F6F',
      '#F88F6F',
      '#BB5B3F'
    ];
    setColors(arrayColor)  

    const utilityDataColors = data?.utilities?.map((value: any, item: any) => ({
      ...data?.utilities[item],
      color: arrayColor[item],
    }))
    const utilityDataLabels = data?.utilities?.map((value: any, item: any) => {
      return value.utilityName;
    })
    setLabels(utilityDataLabels);
    setUtilityMixData(utilityDataColors)
  }

  const optionsUtility: Object = chartOptions(labels, colors);

  return (
    <div className='card card-flush card-border mb-5 mb-xl-10 h-auto' style={{minHeight:'365px'}}>
      <Stack gap={2} className='container mt-5 mb-5 ms-4'>
        <div className='text-dark fw-bolder fs-3'>Utility Mix</div>
        <Stack direction='horizontal' gap={2}>
          <div className='fw-bold fs-6 text-dark'>{utilityMix?.tpvAccepted}</div>
          <div className='text-muted fs-6'>TPVs Accepted</div>
        </Stack>
      </Stack>
      {reload ? (
        <div className="text-center mb-20">
          <Spinner animation="border" className="text-gray-600 text-center" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
      </div>) : (
      <div className='container mb-5'>
        <Row>
          <Col sm md lg='7'>
            <div className='position-relative d-flex flex-center mb-7'>
              {/* <div className='position-absolute translate-middle start-50 top-50 d-flex flex-column flex-center'>
                <span className='fs-4 fw-bold text-gray-400'>TPV Reports</span>
                <span className='fs-3x fw-bolder'>{total}</span>
              </div> */}
              <Chart
                type='donut'
                width={300}
                height={270}
                series={utilSeries || []}
                options={optionsUtility}
                className='d-block'
              />
            </div>
          </Col>
          <Col sm md lg='5'>
            <Stack
              gap={5}
              className='hover-scroll-overlay-y mt-5 mb-5 mt-lg-0 mb-lg-5 pe-lg-n2 me-lg-2 mh-250px'
              data-kt='scroll'
              data-kt-activate='true'
              data-kt-scroll-height='auto'
            >
              {utilityMixData?.map((item: any) => {
                return (
                  <>
                    <div className='d-flex me-15' key={item.utilityName}>
                      <span
                        className='bullet bullet-dot h-10px w-10px me-3 mt-2'
                        style={{backgroundColor: `${item?.color}`}}
                      ></span>
                      <Stack>
                        <span className='fw-bold fs-2'>{item?.tpvAcceptedCount}</span>
                        <span className='fs-6' style={{color: `${item?.color}`}}>
                          {item?.utilityName}
                        </span>
                      </Stack>
                    </div>
                  </>
                )
              })}
            </Stack>
          </Col>
        </Row>
      </div>
  )}
    </div>
  )
}

export default UtilitMix
